import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from "./ProtectedRoute";
// Import pages
import SignInPage from '../pages/Auth/SignInPage';
import SignUpPage from '../pages/Auth/SignUpPage';
import ForgotPasswordPage from '../pages/Auth/ForgotPasswordPage';
import ResetPasswordPage from '../pages/Auth/ResetPasswordPage';
import DashboardPage from '../pages/DataCenter/DashboardPage';
import NotFoundPage from '../pages/Error/NotFoundPage';
import AccessDeniedPage from '../pages/Error/AccessDeniedPage';

// Import Data Center pages
import RDCPage from '../pages/DataCenter/RDC/RDCPage';
import RDCCount from '../pages/DataCenter/RDC/RDCCount';
import RegularRDCPage from '../pages/DataCenter/RDC/RegularRDCPage';
import RDCDownloadsStatusPage from '../pages/DataCenter/RDC/RDCDownloadsStatusPage';
import VDCPage from '../pages/DataCenter/VDC/VDCPage';
import VDCStatus from '../pages/DataCenter/VDC/VDCStatus';
import RegularVDCPage from '../pages/DataCenter/VDC/RegularVDCPage';
import FDCListPage from '../pages/DataCenter/VDC/FDCListPage';
import FDCEditPage from '../pages/DataCenter/VDC/FDCEditPage';
import FDCAppendReuploadPage from '../pages/DataCenter/VDC/FDCAppendReuploadPage';

import CDPage from '../pages/DataCenter/CD/CDPage';
import PccountsPage from '../pages/DataCenter/CD/PccountsPage';
import RSCUploadPage from '../pages/DataCenter/VDC/RSCUploadPage';
import FDCUploadPage from '../pages/DataCenter/VDC/FDCUploadPage';
import FDCPage from '../pages/DataCenter/FDC/FDCPage';
import CustomerExperiencePage from '../pages/DataCenter/FDC/CustomerExperiencePage';
import RegisterCustomerPage from '../pages/DataCenter/FDC/RegisterCustomerPage';
import RDEDownloadsPage from '../pages/DataCenter/RDC/RDEDownloadsPage';
import AdminDashboard from '../pages/Admin/components/AdminDashboard';
import Dashboard from '../pages/Admin/pages/Dashboard';
import UserList from '../pages/Admin/pages/users/UserList';
import UserDetail from '../pages/Admin/pages/users/UserDetail';
import CreateRole from '../pages/Admin/pages/users/CreateRole';
import EditRole from '../pages/Admin/pages/users/EditRole';
import RoleList from '../pages/Admin/pages/users/RolesList';
import RolesAccessMatrix from '../pages/Admin/pages/users/RolesAccessMatrix';
import WebhookLogList from '../pages/Admin/pages/webhooks/WebhookLogList';
import ManageDataPointsPage from '../pages/DataCenter/CD/ManageDataPointsPage';  
import CreateRecordPage from '../pages/DataCenter/CD/CreateRecordPage';  
import EditRecordPage from '../pages/DataCenter/CD/EditRecordPage';  
import CDCount from '../pages/DataCenter/CD/CDCount';
import RegularCDPage from '../pages/DataCenter/CD/RegularCDPage';
import CDBulkUpload from '../pages/DataCenter/CD/CDBlukUpload';
import CountPage from '../pages/Auth/count';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/count" element={<CountPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Main dashboard */}
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />

      {/* Admin routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRole="1">
            <AdminDashboard />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users-list" element={<UserList />} />
        <Route path="users/:id" element={<UserDetail />} />
        <Route path="roles" element={<RoleList />} />
        <Route path="roles/access-matrix" element={<RolesAccessMatrix />} />
        <Route path="roles/create" element={<CreateRole />} />
        <Route path="roles/:id/edit" element={<EditRole />} />
        {/* <Route path="roles/:id" element={<RoleList />} /> */}
        <Route path="webhook-logs" element={<WebhookLogList />} />
      </Route>

      {/* Data Center RDC routes */}
      <Route path="/data-centers/rdc" element={<ProtectedRoute><RDCPage /></ProtectedRoute>} />
      <Route path="/data-centers/rdc/regular" element={<ProtectedRoute><RegularRDCPage /></ProtectedRoute>} />
      <Route path="/data-centers/rdc/count" element={<ProtectedRoute><RDCCount /></ProtectedRoute>} />
      <Route path="/data-centers/rdc/status" element={<ProtectedRoute><RDCDownloadsStatusPage /></ProtectedRoute>} />
      <Route path="/data-centers/rdc/rde" element={<ProtectedRoute><RDEDownloadsPage /></ProtectedRoute>} />
      {/* Data Center VDC routes */}
      <Route path="/data-centers/vdc" element={<ProtectedRoute><VDCPage /></ProtectedRoute>} />
      <Route path="/data-centers/vdc/regular" element={<ProtectedRoute><RegularVDCPage /></ProtectedRoute>} />
      <Route path="/data-centers/vdc/list" element={<ProtectedRoute><VDCStatus /></ProtectedRoute>} />
      <Route path="/data-centers/vdc/fdc-upload" element={<ProtectedRoute requiredPermission="fdc_project:create"><FDCUploadPage /></ProtectedRoute>} />
      <Route path="/data-centers/vdc/rsc-upload" element={<ProtectedRoute><RSCUploadPage /></ProtectedRoute>} />
      <Route path="/data-centers/vdc/fdc-list" element={<ProtectedRoute><FDCListPage /></ProtectedRoute>} />
      <Route path="/data-centers/vdc/fdc-edit" element={<ProtectedRoute><FDCEditPage /></ProtectedRoute>} />
      <Route path="/data-centers/vdc/fdc-reupload-append" element={<ProtectedRoute><FDCAppendReuploadPage /></ProtectedRoute>} />

      <Route path="/data-centers/cd" element={<ProtectedRoute><CDPage /></ProtectedRoute>} />
      <Route path="/data-centers/cd/pc-counts" element={<ProtectedRoute><PccountsPage /></ProtectedRoute>} />
      <Route path="/data-centers/cd/database-counts-result" element={<ProtectedRoute><CDCount /></ProtectedRoute>} />
      <Route path="/data-centers/cd/database-counts" element={<ProtectedRoute><RegularCDPage /></ProtectedRoute>} />
      <Route path="/data-centers/cd/manage-data-points" element={<ProtectedRoute><ManageDataPointsPage /></ProtectedRoute>} />
      <Route path="/data-centers/cd/create" element={<ProtectedRoute><CreateRecordPage /></ProtectedRoute>} />
      <Route path="/data-centers/cd/edit" element={<ProtectedRoute><EditRecordPage /></ProtectedRoute>} />
      <Route path="/data-centers/cd/bulk-upload" element={<ProtectedRoute><CDBulkUpload /></ProtectedRoute>} />
      
      <Route path="/data-centers/fdc" element={<Navigate to="/data-centers/fdc/projects" replace />} />
      <Route path="/data-centers/fdc/projects" element={<ProtectedRoute><FDCPage /></ProtectedRoute>} />
      <Route path="/data-centers/fdc/projects/:id" element={<ProtectedRoute><FDCPage /></ProtectedRoute>} />
      <Route path="/data-centers/fdc/customer-experience" element={<ProtectedRoute><CustomerExperiencePage /></ProtectedRoute>} />
      <Route path="/data-centers/fdc/register-customer" element={<ProtectedRoute><RegisterCustomerPage /></ProtectedRoute>} />

      {/* Error routes */}
      <Route path="/access-denied" element={<AccessDeniedPage />} />
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />

      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/signin" replace />} />
    </Routes>
  );
};

export default AppRoutes;
